'use client';

import { create } from 'zustand';

type ExperienceCartDrawerStore = {
  /** True while the consumer is inside ExperienceShell (drawer available). */
  enabled: boolean;
  open: boolean;
  setEnabled: (enabled: boolean) => void;
  setOpen: (open: boolean) => void;
  openDrawer: () => void;
};

export const useExperienceCartDrawerStore = create<ExperienceCartDrawerStore>((set) => ({
  enabled: false,
  open: false,
  setEnabled: (enabled) => set({ enabled }),
  setOpen: (open) => set({ open }),
  openDrawer: () => set({ open: true }),
}));
